import React from 'react'
import {
  AppBar,
  Button,
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Toolbar,
  Typography,
  DialogActions,
  DialogContent,
} from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
  })
)

interface ICustomDialogContentProps {
  title?: string
  confirmText?: string
  onCancel: () => void
  onSubmit?: (event: any) => void
  children: React.ReactNode | React.ReactElement | string
}

export const CustomDialogContent = ({
  title = 'Add',
  confirmText = 'Add',
  onCancel,
  onSubmit,
  children,
}: ICustomDialogContentProps) => {
  const classes = useStyles()
  return (
    <>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onCancel}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>

          {onSubmit && (
            <Button autoFocus color="inherit" onClick={onSubmit}>
              {confirmText}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <DialogContent>{children}</DialogContent>
      {onSubmit && (
        <DialogActions>
          <Button
            onClick={onSubmit}
            color="primary"
            variant="contained"
            autoFocus
            fullWidth
          >
            {confirmText}
          </Button>
        </DialogActions>
      )}
    </>
  )
}
